import $ from "jquery";
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(function() {
  
  $('.store_url_result a').click(() => false);
  $('.design_url_result a').click(() => false);
  $('.products_url_result a').click(() => false);
  $('.store_url_result a').css({color: '#6f6f6f'});
  $('.design_url_result a').css({color: '#6f6f6f'});
  $('.products_url_result a').css({color: '#6f6f6f'});
  
  // $('.store_url_submit').click ->
  //   modal = $(this).closest('.modal')
  //   $.get('redirect_url', {url: modal.find('.store_url_input').val(), store: modal.find('input[name=store_path_input]').val()}, (data, status, xhr) ->
  //     modal.find('.store_url_result a').unbind 'click'
  //     modal.find('.design_url_result a').unbind 'click'
  //     modal.find('.products_url_result a').unbind 'click'
  //     modal.find('.store_url_result a').css({color: ''})
  //     modal.find('.design_url_result a').css({color: ''})
  //     modal.find('.products_url_result a').css({color: ''})
  //     modal.find('.store_url_submit').hide()
  //     modal.find('.store_url_result a').attr('href', data.base_url + data.login_path)
  //     modal.find('.store_url_result a').text(data.base_url + data.login_path)
  //     modal.find('.design_url_result a').attr('href', data.base_url + data.design_path)
  //     modal.find('.design_url_result a').text(data.base_url + data.design_path)
  //     modal.find('.products_url_result a').attr('href', data.base_url + data.products_path)
  //     modal.find('.products_url_result a').text(data.base_url + data.products_path)
  //     modal.find('.store_url_submit').closest('li').find('.label').addClass('success')
  //     modal.find('.store_url_submit').closest('li').next().find('.label').removeClass('secondary')
  //   )
  
  $(document).on("click", "#modal_bigcommerce_app a", function() {
    $(this).closest('li').find('.label').addClass('success');
    return $(this).closest('li').next().find('.label').removeClass('secondary');
  });
  $(document).on("click", "#modal_3dcart_app a", function() {
    $(this).closest('li').find('.label').addClass('success');
    return $(this).closest('li').next().find('.label').removeClass('secondary');
  });
  
  $('.app').mouseover(function() {
    return $(this).find('.back').show();
  });
  
  return $('.app').mouseout(function() {
    return $(this).find('.back').hide();
  });
});
